import { gql } from 'graphql-request';
import { COMPANY_HOTEL_MARKET_STATE_ITEM_FRAGMENT } from '@app/model/market_state/service/MarketStateGraphQLFragments';


export const PARITY_SNAPSHOT_FRAGMENT = gql`
    ${COMPANY_HOTEL_MARKET_STATE_ITEM_FRAGMENT}
    fragment ParitySnapshotFragment on ParitySnapshot {
        companyHotelId
        dailyItems {
            marketStateId
            requestId
            lastUpdateDate
            statDate
            airportCode
            providerItems {
                provider
                isEmpty
                isAvailable
                isNotAvailable
                isSoldOut
                isLos
                item {
                    ...MarketStateItemFragment
                }
            }
        }
    }
`;

export const OTA_PRICE_STATE_FRAGMENT = gql`
    fragment OtaPriceStateFragment on OtaPriceState {
				id
				triggerId
				hotelId
				filter {
						nights
        }
				statDate
				items {
						provider
						isBrandOffer
						isSoldOut
						price {
								currency
								amount
            }
						url
						iconUrl
        }
		}
`

export const OTA_PRICE_STATE_SNAPSHOT_FRAGMENT = gql`
    fragment OtaPriceStateSnapshotFragment on OtaPriceStateSnapshot {
        isEmpty
				dailyItems {
						stateId
						isSoldOut
						isAvailable
						statDate
            items {
                provider
                isBrandOffer
                isSoldOut
                price {
                    currency
                    amount
                }
                url
                iconUrl
            }
        }
    }
`